<div
  class="chip chip-skeleton loading"
  *ngIf="isLoading; else chip"
  [ngStyle]="skeletonStyles"
></div>

<ng-template #chip>
  <div
    class="chip"
    [ngClass]="[backgroundColorClass, colorClass]"
    [class.padding]="!displayDefaultIcon"
  >
    <span><slot></slot></span>
    <div class="chip__icon" [class.show]="displayDefaultIcon">
      <slot name="icon" (slotchange)="slotChange($event)"></slot>

      <svg
        [class.show]="icon === 'close'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        class="feather"
      >
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>

      <svg
        [class.show]="icon === 'check'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        class="feather"
      >
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>

      <svg
        [class.show]="icon === 'clock'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        class="feather"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <polyline points="12 6 12 12 16 14"></polyline>
      </svg>

      <svg
        [class.show]="icon === 'arrow-left'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        class="feather"
      >
        <line x1="19" y1="12" x2="5" y2="12"></line>
        <polyline points="12 19 5 12 12 5"></polyline>
      </svg>

      <svg
        [class.show]="icon === 'pause-circle'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        class="feather"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="10" y1="15" x2="10" y2="9"></line>
        <line x1="14" y1="15" x2="14" y2="9"></line>
      </svg>

      <svg
        [class.show]="icon === 'alert-triangle'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        class="feather"
      >
        <path
          d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
        ></path>
        <line x1="12" y1="9" x2="12" y2="13"></line>
        <line x1="12" y1="17" x2="12.01" y2="17"></line>
      </svg>
      <svg
        [class.show]="icon === 'slash'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        class="feather feather-slash"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
      </svg>
    </div>
  </div>
</ng-template>
